import { gql } from '@apollo/client';

const GET_DUPLICATE_PIO_ORDERS = gql`
  query GetDuplicatePioOrders($patientId: ID!, $productIds: [ID!]!) {
    duplicatePioOrders(patientId: $patientId, productIds: $productIds) {
      orderId
      orderNumber
      state
      createdAt
      type
      products {
        id
        name
      }
    }
  }
`;

export default GET_DUPLICATE_PIO_ORDERS;
export { GET_DUPLICATE_PIO_ORDERS };
